<script>

export default {
    props: {
        options: {
            type: Object,
            required: false,
            default: function() {
                return {
                    threshold: .9,
                    rootMargin: '0px',
                };
            }
        },
    },
    data () {
        return {
            observer: null,
        }
    },
    methods: {
        loadMore(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (entry.intersectionRatio >= this.options.threshold) {
                        this.$emit('load-more', true);
                    }
                }
            });
        }
    },
    mounted() {
        let options = {
            root: null,
            ...this.options
        };

        this.observer = new IntersectionObserver(this.loadMore, options);
        this.observer.observe(this.$el);
    }
}
</script>

<template>
    <div class="infinite-scroll"></div>
</template>
